import { lazy } from "react";

export const UserProfileAsync = lazy(() => import("./UserProfile"));
